<app-db-single-tenant-restore-from-file-panel
  #restoreFromFilePanel
  *ngIf="restoreType==='FromFile'">
</app-db-single-tenant-restore-from-file-panel>
<app-db-single-tenant-restore-from-db-panel
  #restoreFromDbPanel
  *ngIf="restoreType==='FromDb'">
</app-db-single-tenant-restore-from-db-panel>
